export const detectCountryFromIP = async () => {
    // List of free geolocation APIs to try in order
    const apis = [
        {
            url: "https://ipapi.co/json/",
            parseResponse: (data) => ({
                country_code: data.country_code?.toLowerCase(),
                dial_code: data.country_calling_code,
            }),
        },
        {
            url: "https://ip-api.com/json/",
            parseResponse: (data) => ({
                country_code: data.countryCode?.toLowerCase(),
                dial_code: null,
            }),
        },
        {
            url: "https://ipwhois.app/json/",
            parseResponse: (data) => ({
                country_code: data.country_code?.toLowerCase(),
                dial_code: data.country_phone,
            }),
        },
    ];

    for (const api of apis) {
        try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000);

            const response = await fetch(api.url, {
                signal: controller.signal,
            });

            clearTimeout(timeoutId);

            if (!response.ok) {
                console.warn(`API ${api.url} returned status ${response?.status}`);
                continue; // Try next API
            }

            const data = await response.json();
            const { country_code, dial_code } = api.parseResponse(data);

            if (country_code) {
                console.log("Country detected:", country_code);
                return {
                    country_code,
                    dial_code,
                    success: true
                };
            }
        } catch (error) {
            console.warn(`Error with API ${api.url}:`, error.message);
            // Continue to next API
        }
    }

    // All APIs failed, return default (Saudi Arabia)
    console.log("All geolocation APIs failed, using default: Saudi Arabia");
    return {
        country_code: "sa",
        dial_code: "966",
        success: false
    };
};